<template>
    <div >
      <BaseModal
        v-if="visible && !recNo"
        ModalId="modalId"
        :HideModalFun="onHidden"
        :TitleWindow="$t('Admission.Admission')"
        :width="'40%'"
        :height="'auto'"
        :buttons="[
            { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
            { text: $t('Shared.TitleOK'), variant: 'primary', action: onClickShowReport },                   
        ]"              
        @Close="close"
        >
        <b-row>
          <b-col lg="6" md="6" sm="6">
            <MdDateTime 
              :Label="$t('Shared.datefrom')" 
              :Model="dateFrom"                           
              @input="dateFrom = $event"                            
              :Id="'AdmissionDateFrom'"
              :Type="'date'"                  
              :isRequired="false" 
              :isConfirm="false"
              :ReadOnly="false"
              v-bind:isValid="this.isDateFromValid">
            </MdDateTime>
          </b-col>
          <b-col lg="6" md="6" sm="6">
            <MdDateTime 
              :Label="$t('Shared.dateTo')" 
              :Model="dateTo"                           
              @input="dateTo = $event"                            
              :Id="'AdmissiondateTo'"
              :Type="'date'"                  
              :isRequired="false" 
              :isConfirm="false"
              :ReadOnly="false"
              v-bind:isValid="this.isDateToValid">
            </MdDateTime>
          </b-col>
        </b-row>
      </BaseModal>

      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="$t('Admission.Admission')"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
      >
        <ReportViewer
          ref="Admissions"
          :ReportName="'Admissions'"
          :ReportTitle="$t('Admission.Admission')"
          :IsAnAPIReport="true"
        />
    </DxPopup>
    </div>
</template>

<script>
    import Vue from 'vue'
    import { DxPopup } from 'devextreme-vue/popup';
    import ShowMessage from '@/components/messages/ShowMessage.js'
    import Utils from '@/common/utils'

    export default Vue.extend({
        name: "AdmissionsRep",
        mixins: [ ShowMessage ],
        components: { DxPopup },
        props: {
          patientCode: String,
          closeWindow: Function,
          patientName: String,
          recNo: [String, Number],
          visible: {
            type: Boolean,
            default: false
          },
        },
        data() {
            return {
              isReportVisible: false,
              modalId: 'Admissions',
              emitCloseEvent: false,
              dateFrom: null,
              dateTo: null,
              reportParams: [],
              isDateFromValid: true,
              isDateToValid: true,
            }
        },
        watch: {
          visible(newVal) {
            if (newVal) {
                this.$bvModal.show(this.modalId);
                this.emitCloseEvent= true;
            }
          },
        },
        methods: {

            onShowing(e) {
              let contentElement = e.component.content();
              let titleElement = e.component._$title[0]
              contentElement.style.padding = '0px';
              titleElement.style.padding = '0px 20px'
            },

            onHiddenReport() {
              this.isReportVisible = false
              this.close()
            },

            close() {
              this.emitEventCancel();
            },

            initializePdfParameters() {
              this.reportParams = []
              this.reportParams.push({ paramName: 'dateFrom', paramValue: this.dateFrom})
              this.reportParams.push({ paramName: 'dateTo', paramValue: this.dateTo})
              this.reportParams.push({ paramName: 'patientCode', paramValue: this.patientCode})
              this.reportParams.push({ paramName: 'patientName', paramValue: this.patientName})
              this.reportParams.push({ paramName: 'recNo', paramValue: this.recNo})
            },

            onClickShowReport() {
              if (this.visible && !this.validateForm()) return;
              if (this.visible) this.onHidden();
              
              this.initializePdfParameters();
              this.isReportVisible = true
              this.$refs.Admissions.buildDocument(this.reportParams)
            },

            validate_date_range() {
              return Utils.isDateFromAndDateTo(this.dateFrom, this.dateTo);
            },

            // Método de validación reutilizable
            validateForm() {
              if (!this.validate_date_range()) {
                this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.DateOutRange'), "error");
                return false;
              }
              return true;
            },

            onHidden() {
              if (this.emitCloseEvent) {
                this.$emit('close');
                this.emitCloseEvent= false;
              }
            },

            emitEventCancel() {
              this.emitCloseEvent= false;
              this.$emit('close');
            },
        },
        
        mounted () {
          if (this.recNo)
           this.onClickShowReport()
        },
    })
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  } 
</style>
